import { Navigate } from "react-router";
import { useAppSelector } from "../redux/store";
import type { UserRole } from "../types/api";

interface RequireRoleProps {
  roles: UserRole[];
  children: React.ReactNode;
}

/**
 * Route guard that restricts access to users with one of the specified roles.
 * Redirects clients to /project-home and all others to /login.
 */
export default function RequireRole({ roles, children }: RequireRoleProps) {
  const { user } = useAppSelector((state) => state.login);

  if (!user || !roles.includes(user.role)) {
    const fallback =
      user?.role === "client" || user?.role === "employee"
        ? "/project-home"
        : "/login";
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
